import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem'; // import * as i18n from ' b:components_CampaignSelector t:i18n';
import { CampaignAndGroupSelectorEntityToSelectType } from '../../../typings/state';
import { Selector, SelectorItems } from '../Selector/Selector';

import * as keyset from './CampaignSelector.i18n';

const i18n = i18nFactory(keyset);

export interface CampaignSelectorProps {
    items?: Array<SelectorItems>;
    entitityType?: CampaignAndGroupSelectorEntityToSelectType;
    onInputChange: (text: string) => void;
    onItemSelect: (selectorItems: SelectorItems) => void;
    inputText?: string;
    error?: boolean;
    itemSelected?: SelectorItems;
    isActive: boolean;
    isLoading: boolean;
}

export const CampaignSelector = ({
    error,
    items,
    onInputChange,
    inputText,
    onItemSelect,
    isActive,
    itemSelected,
    isLoading,
    entitityType
}: CampaignSelectorProps) => (
    <Selector
        entitityType={entitityType}
        items={items}
        cls={Bem.cls('campaign-selector')}
        onInputChange={onInputChange}
        onItemSelect={onItemSelect}
        placeholder={i18n('search-by-campaign')}
        emptyText={i18n('no-campaign-found')}
        errorText={error ? i18n('error') : ''}
        itemSelected={itemSelected}
        isLoading={isLoading}
        inputText={inputText}
        isActive={isActive}
    />
);
